import { TextStyle } from '@ticketmaster/global-design-system';
import React from 'react';
import { TicketAdditionalInfo, TicketModel } from '@/v2/models/ticketModel';

function formatAdditionalInfo(data: any) {
  return (
    <div key={data.key} style={{textAlign: 'left'}}>
      <TextStyle.Etna>
        {data.value}
      </TextStyle.Etna>
    </div>
  );
}

export function getAdditionalInfos(ticket: TicketModel, isFrontOfTicket: boolean) {
  const infos = isFrontOfTicket
    ? ticket.additionalInfos.filter((data: any) => data.showInFront)
    : ticket.additionalInfos.filter((data: any) => data.showInBack);

  const formatInfos = (infos: TicketAdditionalInfo[]) => {
    return infos.map((data: TicketAdditionalInfo) => {
      if (data.value) {
        return formatAdditionalInfo(data);
      }
      return null;
    }).filter(Boolean);
  };

  infos.sort((a: TicketAdditionalInfo, b: TicketAdditionalInfo) => a.index - b.index)
  return formatInfos(infos);
}
